import { SOMETHING_WENT_WRONG } from "../Constants/messages";

export const parseApiError = (error: any) => {
  return error?.response?.data?.message || SOMETHING_WENT_WRONG;
};
